import axios from 'axios';
import { arrayToMap, getRole, getId } from '../../../../utils';
import { getProcessorsQuery, getCommoditiesQuery } from '../../queries';
import { buildExpressQuery } from '../../queries/builders';
import generateErrorMessage from '../../utils/generateErrorMessage';
import { listProcessedFluidRouteSessionsQuery } from '../queries';

const listProcessedFluidRouteSessions = async ({ start, end, withoutPickup = false, withoutDropoff = false, withPickup = false, withoutInProgressDropoff = false } = {}) => {
    try {
        const params = { start, end, withoutPickup, withoutDropoff, withPickup, withoutInProgressDropoff };
        const role = getRole();
        if (role === 'processor') {
            params.processor_id = getId();
        }
        if (role === 'transport') {
            params.hauling_id = getId();
        }

        const query = listProcessedFluidRouteSessionsQuery(params);
        const response = await axios.get(query);
        const routeSessions = response.data;

        const [processors, commodities] = await Promise.all([axios.get(getProcessorsQuery({ queryBuilder: buildExpressQuery })), axios.get(getCommoditiesQuery())]);
        const processorsMap = arrayToMap(processors.data, '_id');
        const commoditiesMap = arrayToMap(commodities.data, 'type');

        const results = routeSessions.map((routeSession) => {
            const origin = processorsMap[routeSession.pickup_id?.origin_processor_id] || undefined;
            const destination = processorsMap[routeSession.dropoff_id?.destination_processor_id] || undefined;
            const commodity = commoditiesMap[routeSession.commodity_type] || undefined;

            return { ...routeSession, origin, destination, commodity };
        });

        // TODO this is awful.
        // Should either be two requests (bad) or OR mactch in query (good)
        if (getRole() === 'processor') {
            const userId = getId();
            const filteredResults = results.filter((session) => session.origin_processor_id?._id === userId || session.destination_processor_id?._id === userId);
            return filteredResults;
        }

        return results;
    } catch (error) {
        return generateErrorMessage(error);
    }
};

export default listProcessedFluidRouteSessions;
